import React from "react";
import { Label, Popup } from "semantic-ui-react";

export const InvoiceComponentCODLabel = ({ customer = {} }) => {
    if (!customer?.cash_on_delivery) {
        return null;
    }

    return (
        <Popup
            size="tiny"
            content="Cash On Delivery"
            trigger={
                <Label color="brown" size="small">
                    COD
                </Label>
            }
        />
    );
};
